var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39738 9.81183C8.78791 10.2024 9.42107 10.2024 9.81159 9.81183C10.2021 9.42131 10.2021 8.78814 9.81159 8.39762L8.39738 9.81183ZM2.26912 0.855145C1.8786 0.464621 1.24543 0.464621 0.854909 0.855145C0.464385 1.24567 0.464385 1.87883 0.854909 2.26936L2.26912 0.855145ZM9.81159 2.26936C10.2021 1.87883 10.2021 1.24567 9.81159 0.855145C9.42107 0.464621 8.78791 0.464621 8.39738 0.855145L9.81159 2.26936ZM0.854909 8.39762C0.464384 8.78814 0.464385 9.42131 0.854909 9.81183C1.24543 10.2024 1.8786 10.2024 2.26912 9.81183L0.854909 8.39762ZM9.81159 8.39762L2.26912 0.855145L0.854909 2.26936L8.39738 9.81183L9.81159 8.39762ZM8.39738 0.855145L0.854909 8.39762L2.26912 9.81183L9.81159 2.26936L8.39738 0.855145Z",
    fill: "#001854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/icon-x.b39cef7678952cfefd0563d04340ab9c.svg";
export { ForwardRef as ReactComponent };